import React from 'react';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { Button, HeaderText } from '../../../../ui';
import { IdentityVerificationStatus } from '../../../../../api/Providers/VerificationDetails';

export type VerificationDetailsBannerProps = {
  identityVerification: Pick<IdentityVerificationStatus, 'needs_mailing_address_charges'>;
};

const VerificationDetailsBanner: React.FC<VerificationDetailsBannerProps> = ({
  identityVerification,
}) => {
  const {
    needs_mailing_address_charges,
  } = identityVerification || {};

  return (
    <Inline
      padding={16}
      color={colors.slate}
      alignItems="center"
      justifyContent="space-between"
      testID="verificationDetailsBanner"
    >
      <HeaderText color={colors.whiteWash} level={3}>
        Update {needs_mailing_address_charges ? 'your mailing address' : 'information'} to process payments and enable a cancellation policy.
      </HeaderText>
      <Button
        link="provider.settings_menu.payments"
        linkParams={needs_mailing_address_charges ? {
          openMailingAddress: true,
        } : {
          openVerificationDetails: true,
        }}
        clickTracking={needs_mailing_address_charges
          ? 'P Clicked Mailing Address Banner'
          : 'P Clicked Verification Details Banner'}
        size="small"
        appearance="outline"
        testID="update"
      >
        Update
      </Button>
    </Inline>
  );
};

export default VerificationDetailsBanner;
